export function getSessionStorage(name){
	return sessionStorage.getItem(name);
}

export function setSessionStorage(name, value){
	return sessionStorage.setItem(name, value);
}

export function removeSessionStorage(name){
	return sessionStorage.removeItem(name);
}